export default {
  velt: {
    openPanel: 'टिप्पणी पैनल खोलें',
    closePanel: 'टिप्पणी पैनल बंद करें',
    panel: 'टिप्पणी पैनल',
    tabs: 'टिप्पणी पैनल टैब',
    comments: 'टिप्पणियाँ',
    settings: 'सेटिंग्स और अनुमतियाँ',
    dragOrTapComment: 'टिप्पणी जोड़ने के लिए खींचें, या टिप्पणियाँ देखने के लिए टैप करें',
    assignComment: 'टिप्पणी असाइन करें',
    markAsUnread: 'अपठित के रूप में चिह्नित करें',
    markAsRead: 'पठित के रूप में चिह्नित करें',
    unsubscribe: 'सदस्यता रद्द करें',
    subscribe: 'सदस्यता लें',
    deleteThread: 'थ्रेड हटाएँ',
    editComment: 'टिप्पणी संपादित करें',
    emptyPlaceholder: 'प्रतिक्रिया दें, प्रश्न पूछें या अपनी टीम के सदस्यों के लिए एक नोट छोड़ें',
    searchPlaceholder: 'टिप्पणियाँ खोजें',
    commentPlaceholder: '{page} पर टिप्पणी करें',
    replyPlaceholder: 'उत्तर दें....',
    filterPages: 'पृष्ठ',
    filterAuthor: 'लेखक',
    filterTagged: 'टैग किए गए',
    statusOpen: 'खुला',
    statusResolved: 'हल किया गया',
    anonymous: 'अनाम',
    settingsPanel: {
      title: 'कौन टिप्पणी कर सकता है?',
      everyoneLabel: 'सभी',
      restrictedLabel: 'केवल आमंत्रित सहयोगी',
      emailsLabel: 'ईमेल',
      emailsPlaceholder: 'एक ईमेल जोड़ें और Enter दबाएँ',
    },
  },
}
